import { StyledIcon } from 'fitify-ui/src/Icon/Icon.Styled'
import { css, styled } from 'styled-components'

import type { ColorVariant, UnselectedVariant } from './Radio.Types'

export const StyledRadio = styled.div<{
  $colorVariant: ColorVariant
  $isDisabled: boolean
  $isSelected: boolean
  $unselectedVariant: UnselectedVariant
}>`
  display: flex;
  width: 28px;
  height: 28px;
  align-items: center;
  justify-content: center;

  ${StyledIcon} {
    width: 21px;
    height: 21px;

    ${({
      $colorVariant,
      $isDisabled,
      $isSelected,
      $unselectedVariant,
      theme,
    }) => {
      if ($colorVariant === 'inverse') {
        return css`
          color: ${theme.colors['N Content/Inverse']};
          cursor: ${$isDisabled ? 'not-allowed' : 'pointer'};
        `
      }
      if ($isDisabled) {
        return css`
          color: ${theme.colors['N Content/Disabled']};
          cursor: not-allowed;
        `
      }
      if ($isSelected) {
        return css`
          color: ${theme.colors['N General/Brand']};
          cursor: pointer;
        `
      }
      return css`
        color: ${() => {
          switch ($unselectedVariant) {
            case 'circle':
              return theme.colors['N Content/Tertiary']
            case 'chevron-forward':
            case 'chevron-forward-circle':
            default:
              return theme.colors['N General/Brand']
          }
        }};
        cursor: pointer;
      `
    }};
  }
`
